import { NSARouterMakerResult } from 'namirasoft-account-react';
import { EncodingOperation, NamingConvention, ObjectService } from 'namirasoft-core';
import { GatewayType, OfferFullRow } from 'namirasoft-payment';
import { NSButtonBlue, NSLoading, NSSection } from 'namirasoft-site-react';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PaymentLayout } from '../PaymentLayout';
import { PaymentProps } from '../PaymentProps';
import { PaymentRoutes } from '../PaymentRoutes';
import NSPOfferCard from '../components/NSPOfferCard';
import NSPPaymentMethod from '../components/NSPPaymentMethod';

export interface OfferGatewayPageProps extends NSARouterMakerResult, PaymentProps { }
export interface OfferGatewayPageState
{
    offer: OfferFullRow | null;
    processing: boolean;
}

function OfferGatewayPage(props: OfferGatewayPageProps)
{
    let NSPPaymentMethodRef = useRef<NSPPaymentMethod>(null);

    let [state, setState] = useState<OfferGatewayPageState>({ offer: null, processing: false });

    let { id, product_slug, sales_item_slug } = useParams();

    useEffect(() =>
    {
        if (!id)
            return;

        props.servers.payment.offer.Get(id).then((offer =>
        {
            let { gateway } = props.url.getQueryStrings();

            if (gateway)
                handleClick(offer, () => { });
            else
                setState(prevState => ({ ...prevState, offer }));
        }
        )).catch(() => { });
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, []);

    async function handleClick(offer: OfferFullRow | null, onFinsihed: () => void)
    {
        let cancel_url: string = "";
        try
        {
            if (!offer)
                return;

            let callback = props.url.getQuery("callback");
            if (callback)
                try
                {
                    callback = EncodingOperation.Base64Decode(callback);
                } catch (error)
                {
                    callback = "";
                }
            if (!callback)
                if (product_slug)
                {
                    callback = PaymentRoutes.SalesItemList(product_slug, false, "");
                    if (sales_item_slug)
                        callback = PaymentRoutes.OfferList(product_slug, sales_item_slug, false, "");
                }

            let success_url: string;
            if (offer?.subscription)
            {
                cancel_url = PaymentRoutes.SubscriptionCanceled(offer?.subscription.id, true, callback);
                success_url = PaymentRoutes.SubscriptionSuccessful(offer?.subscription.id, true, callback);
            }
            else
            {
                cancel_url = PaymentRoutes.PaymentCanceled(true, callback);
                success_url = PaymentRoutes.PaymentSuccessful(true, callback);
            }
            setState(prev => ({ ...prev, processing: true }));
            let gateway = NSPPaymentMethodRef.current?.getValue() ?? GatewayType.Stripe;
            let gw = props.url.getQuery("gateway");
            if (gw)
            {
                gw = NamingConvention.auto.convert(gw, NamingConvention.Pascal_Case);
                gateway = new ObjectService(gw, true).getEnum(GatewayType, GatewayType.Stripe);
            }

            try
            {
                let res = await props.servers.payment.offer.Checkout(offer?.id, {
                    gateway,
                    cancel_url: `${window.location.origin}${cancel_url}`,
                    success_url: `${window.location.origin}${success_url}`,
                });
                if (res)
                    window.location.href = res.url;
                else
                    window.location.href = success_url;
            }
            catch
            {
                // The server already reported the error through the notifier.
                if (cancel_url)
                    window.location.href = cancel_url;
            }
        }
        catch (error)
        {
            // Input validation and local errors are not reported by the server, so notify here.
            props.notifier.onError(error as Error);
        }
        finally
        {
            onFinsihed();
        }
    }

    function onClickedRadio(title: string)
    {
        if (title)
            setState(prevState => ({ ...prevState, selectedGateway: title as GatewayType, selectedRadio: title }));
    }

    return (
        <PaymentLayout {...props}
            action={{
                title: 'Offer Gateway ',
                description: 'Choose your preferred payment method.',
                menus: {}
            }}
        >
            <NSSection>
                {
                    (state.offer && !state.processing) ?
                        <>
                            <NSPOfferCard
                                {...props}
                                offer={state.offer}
                                offer_items={state.offer.offer_item}
                                subscription={state.offer.subscription}
                                button={{ visible: false }}
                            />
                            <NSPPaymentMethod
                                ref={NSPPaymentMethodRef}
                                {...props}
                                onClickedRadio={onClickedRadio}
                            />
                            <NSButtonBlue
                                title='Continue'
                                onClick={{
                                    action: (onFinsihed) => handleClick(state.offer, onFinsihed),
                                    showLoading: true
                                }}
                            />
                        </>
                        :
                        <NSLoading />
                }
            </NSSection>
        </PaymentLayout >
    );
}

export default OfferGatewayPage;